function handleformData (file, params) {
  let form = new window.FormData()
  if (file) {
    if (file.name) {
      form.append('file', file, file.name)
    } else {
      form.append('file', file)
    }
  }
  Object.keys(params).forEach(key => {
    form.append(key, params[key])
  })
  return form
}

export default function uploadFile (url, file, params = {}) {
  let qs = document.querySelector('meta[name=csrf-token]')
  let form = handleformData(file, params)

  return window
    .fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': qs && qs.content
      },
      body: form,
      credentials: 'same-origin'
    })
    .then(response => response.json())
}
